import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Icon } from "../common/Icon";

export default function CalculatorCard({ calc }) {
  return (
    <Link
      to={`/calculators/${calc.slug}`}
      data-testid={`calc-card-${calc.slug}`}
      className="group flex flex-col rounded-2xl border border-border bg-card p-6 transition-transform duration-200 hover:-translate-y-1 hover:shadow-md"
    >
      <span className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-brand/10 text-brand transition-colors group-hover:bg-brand group-hover:text-white">
        <Icon name={calc.icon} className="h-5 w-5" />
      </span>
      <h3 className="font-heading text-lg font-bold text-foreground">{calc.name}</h3>
      <p className="mt-1 flex-1 text-sm text-muted-foreground">{calc.tagline}</p>
      <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-brand transition-colors group-hover:text-action">
        Open calculator <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
      </span>
    </Link>
  );
}
